// extracted by css-extract-rspack-plugin
export default {"title":"title-KwZYzN","name":"name-Hqjih7"};